// src/.../sidebar/EmergencySection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TextField } from '@mui/material';

function EmergencySection({ value, readOnly = true, onChange }) {
  const contact = value?.contactoEmergencia?.[0] || { nombreEmergencia: '', telefonoEmergencia: '' };

  if (readOnly) {
    return (
      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Contacto de Emergencia</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">Nombre</Typography>
            <Typography sx={{ mt: .5 }}>{contact.nombreEmergencia || '—'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Teléfono</Typography>
            <Typography sx={{ mt: .5 }}>{contact.telefonoEmergencia || '—'}</Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  // Modo edición
  const updateContact = (key, val) => {
    onChange?.((prev) => {
      const list = Array.isArray(prev?.contactoEmergencia) ? [...prev.contactoEmergencia] : [];
      const first = { ...(list[0] || {}) };
      if (key === 'nombreEmergencia') first.nombreEmergencia = val;
      if (key === 'telefonoEmergencia') first.telefonoEmergencia = val;
      list[0] = first;
      return { ...prev, contactoEmergencia: list };
    });
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Contacto de Emergencia</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <TextField
          size="small"
          label="Nombre"
          value={contact.nombreEmergencia || ''}
          onChange={(e) => updateContact('nombreEmergencia', e.target.value)}
        />
        <TextField
          size="small"
          label="Teléfono"
          value={contact.telefonoEmergencia || ''}
          onChange={(e) => updateContact('telefonoEmergencia', e.target.value)}
        />
      </Box>
    </Box>
  );
}

EmergencySection.propTypes = {
  value: PropTypes.object,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default EmergencySection;
